export const NA_REGION = 'NA';
export const NA_COUNTRIES = ['US', 'CA'];
export const NA_LOCALE = 'en-US';
export const EU_LOCALE = 'en-150';

export interface LocaleFormats {
  /** date-fns format the datepicker input shows, and the end date of a recurrence rule. */
  dateFormat: string;
  placeholder: string;
  /** date-fns format for a date quoted in a validation message. */
  messageDateFormat: string;
  /** Angular date pipe format of the request-sent timestamp. */
  requestSentFormat: string;
}

// The NA hint matches what rocket-ui's datepicker shows once a date is picked (MM/dd/yy); the design guide's MM/DD/YYYY
// needs that format exposed there first (KOR-15190).
const FORMATS: Record<string, LocaleFormats> = {
  [NA_LOCALE]: {
    dateFormat: 'MM/dd/yy',
    placeholder: 'MM/DD/YY',
    messageDateFormat: 'MM/dd/yyyy',
    requestSentFormat: "MMM d, yyyy 'at' h:mm a",
  },
  [EU_LOCALE]: {
    dateFormat: 'dd/MM/yyyy',
    placeholder: 'DD/MM/YYYY',
    messageDateFormat: 'dd/MM/yyyy',
    requestSentFormat: "d MMM yyyy 'at' HH:mm",
  },
};

/** Any locale this app has no formats for is NA, so an unexpected backend value never breaks rendering. */
export const toSupportedLocale = (locale?: string | null): string => (locale && locale in FORMATS ? locale : NA_LOCALE);

export const localeFormats = (locale?: string | null): LocaleFormats => FORMATS[toSupportedLocale(locale)];
